export function renderMetaPwa() {
    return (
    <>
        <link rel="manifest" href="/manifest.json" />
    </>
    );
  }
  
  export default renderMetaPwa;
  